import { useWSModal, WSForm } from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { queriesComplianceEntities } from "@query";
import {
  FormDataAddress,
  FormPartialAddress
} from "../../../../Onboarding/components/FormPartialAddress";
import { getValidationSchemaAddress } from "../../../../../shared/validators/address/validationSchemaAddress";
import { LayoutFormEdit } from "./LayoutFormEdit";

type FormData = { newValue: FormDataAddress };

type Props = {
  onClose: () => void;
};

export const FormEditAddress: React.FC<Props> = props => {
  const queryComplianceEntities =
    queriesComplianceEntities.listComplianceEntities.useQuery({});
  const primaryEntity = queryComplianceEntities.data?.data?.find(
    entity => !entity.subject
  );
  const [mutate, meta] =
    queriesComplianceEntities.updateComplianceEntity.useMutation({
      dependencies: [
        queriesComplianceEntities.listComplianceEntities.queryKeyBase
      ],
      onSuccess: props.onClose
    });

  const address = primaryEntity?.physicalAddress;
  const country =
    address?.country || primaryEntity?.jurisdictionCountry || "US";

  return (
    <WSForm<FormData>
      onSubmit={data => {
        if (!primaryEntity?.id) {
          return;
        }

        mutate({
          complianceEntityId: primaryEntity.id,
          complianceEntityUpdate: {
            physicalAddress: {
              line1: data.newValue.addressLine1 || undefined,
              line2: data.newValue.addressLine2 || undefined,
              city: data.newValue.city || undefined,
              state: data.newValue.state || undefined,
              postalCode: data.newValue.postalCode || undefined,
              country
            }
          }
        });
      }}
      defaultValues={{
        newValue: {
          addressLine1: address?.line1 || "",
          addressLine2: address?.line2 || "",
          city: address?.city || "",
          state: address?.state || null,
          postalCode: address?.postalCode || ""
        }
      }}
      validationSchema={Yup.object({
        newValue: getValidationSchemaAddress(country)
      })}
    >
      <LayoutFormEdit
        isLoading={meta.isLoading}
        error={meta.error}
        onCancel={props.onClose}
      >
        <FormPartialAddress country={country} name="newValue" />
      </LayoutFormEdit>
    </WSForm>
  );
};

export const useModalEditAddress = () =>
  useWSModal(FormEditAddress, {
    title: "Address",
    size: "S"
  });
